var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['v-select__option', { 'v-select__option--disabled': _vm.disabled }],attrs:{"tabindex":"0"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.emitValue()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }